import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useUser } from './Context/UserContext';
import profileImg from "../assets/logo.png";
import ViewAllVendors from "./ViewAllVendors";
import "../styles/ViewAllInvoiceDeptHead.css";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "./DashboardLayout";

const ViewAllInvoicesDeptHead = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCard, setShowCard] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null); // or invoice
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("history"); // or "history"
    const [comment, setComment] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [info, setinfo] = useState(null);
    const [VendorInfo, setVendorInfo] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [subTab, setSubTab] = useState("details");
    //const [isEditing, setIsEditing] = useState(false);
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [verifierError, setVerifierError] = useState("");
    const [emailApprovalError, setemailApprovalError] = useState("");
    const [poError, setpoError] = useState("");
    const [prError, setprError] = useState("");
    const [quotationError, setquotationError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(3);
    const { user: loggedInUser } = useUser();
    const [users, setUsers] = useState([]);
    const { user } = useUser();
    const [approverId, setApproverId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [supplierTypes, setSupplierTypes] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [verifiers, setVerifiers] = useState([]);
    const [files, setFiles] = useState({});
    const [vendorFiles, setVendorFiles] = useState({});
    const [poFiles, setPoFiles] = useState({});
    const [formData, setFormData] = useState({});
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewTitle, setPreviewTitle] = useState("");
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [backendStatus, setBackendStatus] = useState(null);

    const FINAL_STATUSES = [12, 9, 10, 11];

    const isFinalStatus = FINAL_STATUSES.includes(backendStatus);

    const isApproved = backendStatus === 12;
    const isRejected = [9, 10, 11].includes(backendStatus);
    const BASE_URL = "/";
    const [approvedInvoices, setApprovedInvoices] = useState([]);
    const [rejectedInvoices, setRejectedInvoices] = useState([]);
    //const isApproved = String(selectedInvoice?.approvalStatus) === "1";
    //const isRejected = String(selectedInvoice?.approvalStatus) === "2";
    <ViewAllVendors
        activeTab={activeTab}
        subTab={subTab}
        setSubTab={setSubTab}
        isEditing={isEditing}
        selectedVendor={selectedInvoice} // can rename internally if needed
        //handleInputChange={handleInputChange}
        setIsEditing={setIsEditing}
    />

    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);

    const handleReviewClick = async (selected) => {
        if (!selected) return;
        setSelectedInvoice(null);
        setInvoiceInfo(null);
        setVendorInfo(null);
        setFiles({});
        setPoFiles({});
        setApprovalHistory([]);
        setComment("");
        setBackendStatus(null);
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        //setSelectedInvoice({
        //    ...selected,
        //    index
        //});
        setSelectedInvoice({
            ...selected,
            approvalStatus: "",      // important
            rejectionSendTo: "",     // important
        });

        setActiveTab("infoInvoice"); // open Invoice Info tab

        try {
            // Fetch invoice info by invoice ID
            const invoiceRes = await axios.get(
                `/api/invoices/info/${selected.id}`
            );

            const invoiceData = invoiceRes.data;

            setInvoiceInfo(invoiceData); // ✅ correct

            const userId = invoiceData?.userid;

            if (!userId) {
                alert("User ID not available!");
                return;
            }

            // Fetch vendor info using userid from invoice info
            const vendorRes = await axios.get(
                `/api/vendordetails/vendor-by-userid/${invoiceData.userid}`
            );
            const vendorData = { ...vendorRes.data, id: vendorRes.data.vendorId };
            setSelectedVendor(vendorData);

            // Fetch vendor files
            const filesRes = await axios.get(
                `/api/vendor/files/vendor/${vendorData.vendorId}`
            );

            const filesMapped = {};
            filesRes.data.forEach((file) => {
                const key = file.docName.toUpperCase();
                filesMapped[key] = {
                    fileId: file.fileId,
                    fileName: file.fileName,
                    fileExtension: file.fileExtension,
                    filePath: `/api/vendor/files/${file.fileId}?mode=view`,
                };
            });
            setFiles(filesMapped);

            setShowModal(true);

        } catch (err) {
            console.error("Error fetching invoice or vendor info:", err);
            setSelectedVendor(null);
            setFiles({});
            alert("Unable to load vendor details.");
        }
    };



    useEffect(() => {
        if (invoiceInfo?.userid) {
            axios
                .get(`/api/vendordetails/vendor-by-userid/${invoiceInfo.userid}`)
                .then((res) => {
                    console.log("Vendor Info:", res.data);
                    setVendorInfo(res.data);
                    setSelectedVendor(res.data);
                })
                .catch((err) => {
                    console.error("Error fetching vendor info", err);
                    setVendorInfo(null);
                });
        }
    }, [invoiceInfo]);


    useEffect(() => {
        if (!selectedVendor?.vendorId) return;

        axios
            .get(`/api/vendor/files/vendor/${selectedVendor.vendorId}`)
            .then((res) => {
                const filesMapped = {};
                res.data.forEach((file) => {
                    const key = file.docName.toUpperCase(); // PAN, GST, MSME, CHEQUE
                    filesMapped[key] = {
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileExtension: file.fileExtension,
                        filePath: `/api/vendor/files/${file.fileId}?mode=view`, // preview link
                    };
                });
                setFiles(filesMapped);
            })
            .catch((err) => {
                console.error("Error fetching vendor files:", err);
                setFiles({});
            });
    }, [selectedVendor]);


    const handleFileChange = (e) => {
        const { name, files: selectedFiles } = e.target;

        if (selectedFiles && selectedFiles.length > 0) {
            setFiles((prev) => ({
                ...prev,
                [name]: selectedFiles[0]
            }));
        }
    };

    const statusMapping = {
        Pending: 3,
        Rejected: 2,
        Approved: 1
    };
    const mapBackendStatusToUI = (status) => {
        if (status === 12) return "1";  // Approved
        if (status === 9|| status === 10 || status === 11) return "2"; // Rejected
        return "3"; // Pending
    };

    const mapInvoiceSendTo = (status) => {
        if (status === 9) return "PO";
        if (status === 10) return "Security";
        if (status === 11) return "Vendor";
        return "";
    };
    useEffect(() => {
        const fetchInvoices = async () => {
            if (!loggedInUser?.empId) return;

            setLoading(true);
            try {
                const res = await axios.get(
                    "/api/invoices/dept-list",
                    {
                        params: {
                            deptHeadId: loggedInUser.empId,
                            statusId: selectedStatus,
                            search: searchTerm
                        }
                    }
                );
                setInvoices(res.data || []);
            } catch (err) {
                console.error("Error fetching invoices:", err);
                setInvoices([]);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoices();
    }, [selectedStatus, loggedInUser?.empId, searchTerm]);
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedInvoices = [...invoices].sort((a, b) => {
            let valueA, valueB;

            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });

        setInvoices(sortedInvoices);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const invoicesPerPage = 6;

    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
        if (!selectedInvoice?.id) return;

        console.log("Invoice ID being sent:", selectedInvoice.id);

        axios
            .get(`/api/invoices/approval-history/${selectedInvoice.id}`)
            .then((res) => {
                console.log("APPROVAL HISTORY:", res.data);
                setHistoryData(res.data);
            })
            .catch((err) => {
                console.error("Error fetching approval history:", err);
                setHistoryData([]);
            });

    }, [activeTab, selectedInvoice]);

    useEffect(() => {
        if (activeTab !== "infoInvoice") return;

        const invoiceId = selectedInvoice?.id || selectedInvoice?.ID;
        if (!invoiceId) return;

        axios
            .get(`/api/invoices/info/${invoiceId}`)
            .then((res) => {
                console.log("Invoice Info:", res.data);
                setInvoiceInfo(res.data); // <-- use res.data directly
            })
            .catch((err) => {
                console.error("Error fetching invoice info:", err);
            });

    }, [activeTab, selectedInvoice]);



    // Pagination
    const totalPages = Math.ceil(invoices.length / invoicesPerPage);
    const startIndex = (currentPage - 1) * invoicesPerPage;
    const currentInvoices = invoices.slice(startIndex, startIndex + invoicesPerPage);


    const handlePageChange = (action) => {
        if (action === "first") setCurrentPage(1);
        else if (action === "prev" && currentPage > 1) setCurrentPage(prev => prev - 1);
        else if (action === "next" && currentPage < totalPages) setCurrentPage(prev => prev + 1);
        else if (action === "last") setCurrentPage(totalPages);
    };

    useEffect(() => {
        axios
            .get("/api/supplier/supplier-types")
            .then((res) => {
                setSupplierTypes(res.data);
            })
            .catch((err) => {
                console.error("Error fetching supplier types:", err);
                setSupplierTypes([]);
            });
    }, []);

    useEffect(() => {
        if (!selectedInvoice?.id) return;

        console.log("📡 Calling API with recordId:", selectedInvoice.id);

        axios
            .get(`/api/supplier/invoice-approval-data/${selectedInvoice.id}`)
            /*.get(`/api/supplier/invoice-approval-data/39`)*/
            .then((res) => {
                const data = res.data;

                console.log("✅ API ResponseDEPT,VERIFIER:", data);

                // 1️⃣ First set dropdown lists
                setDepartmentHeads(data.departmentHeads || []);
                setVerifiers(data.verifiers || []);

                // 2️⃣ Then update selectedInvoice AFTER options exist
                setTimeout(() => {
                    setSelectedInvoice((prev) => ({
                        ...prev,
                        supplierType: data.supplierType ? String(data.supplierType) : "",
                        departmentHead: data.departmentHeadId || "",
                        verifier: data.verifierId || ""
                    }));
                }, 0);
            })
            .catch((err) => {
                console.error("❌ Error loading approval data:", err);
            });

    }, [selectedInvoice?.id]);


    const handleSaveStatus = async () => {

        let isValid = true;

        if (
            String(selectedInvoice?.approvalStatus) !== "1" &&
            String(selectedInvoice?.approvalStatus) !== "2"
        ) {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }

        if (!selectedInvoice?.comment || selectedInvoice.comment.trim() === "") {
            setCommentError("Comments are required");
            isValid = false;
        }


        if (
            selectedInvoice?.approvalStatus === "2" &&
            !selectedInvoice?.rejectionSendTo
        ) {
            setRejectionSendToError("Please select where to send");
            isValid = false;
        }

        if (!isValid) return;

        try {

            const formData = new FormData();

            formData.append("InvoiceId", selectedInvoice.id);
            formData.append("InvoiceNo", selectedInvoice.invoiceNo);
            formData.append("ApprovalStatus", selectedInvoice.approvalStatus); // ✅ dynamic
            formData.append("DeptHeadID", loggedInUser.empId);
            formData.append("Comments", selectedInvoice.comment);

            if (selectedInvoice.approvalStatus === "2") {
                formData.append("RejectionSendTo", selectedInvoice.rejectionSendTo);
            }

            const response = await axios.post(
                "/api/invoice/depthead-approval",
                formData
            );

            if (response.status === 200) {

                // ✅ backend success check (recommended)
                if (!response.data?.success) {
                    alert(response.data?.message || "Something failed");
                    return;
                }

                alert(response.data.message || "Saved successfully");

                // ✅ REMOVE from pending
                setInvoices(prev =>
                    prev.filter(inv => inv.id !== selectedInvoice.id)
                );

                // ✅ OPTIONAL (status text for future use)
                let updatedInvoice = { ...selectedInvoice };

                if (selectedInvoice.approvalStatus === "1") {
                    updatedInvoice.approvalStatus =
                        "Approved by Dept Head, Pending from Finance";

                    updatedInvoice.backendStatus = 10; // adjust if needed

                    // OPTIONAL
                    // setApprovedInvoices(prev => [...prev, updatedInvoice]);

                } else if (selectedInvoice.approvalStatus === "2") {

                    const sendTo = Number(selectedInvoice.rejectionSendTo);

                    if (sendTo === 3)
                        updatedInvoice.approvalStatus = "Rejected by Dept Head, Pending from PO";
                    else if (sendTo === 4)
                        updatedInvoice.approvalStatus = "Rejected by Dept Head, Pending from Security";
                    else if (sendTo === 5)
                        updatedInvoice.approvalStatus = "Rejected by Dept Head, Pending from Vendor";

                    updatedInvoice.backendStatus = 6;

                    // OPTIONAL
                    // setRejectedInvoices(prev => [...prev, updatedInvoice]);
                }

                setShowModal(false);
                setIsEditing(false);
            }

        } catch (error) {
            console.error("Error saving approval:", error);
            alert("Something went wrong while saving.");
        }
    };

    const mapSendToToDropdownValue = (sentBackTo) => {
        console.log("🔄 Mapping SentBackTo:", sentBackTo);
        if (sentBackTo === "PO") return "3";
        if (sentBackTo === "Security") return "4";
        if (sentBackTo === "Vendor") return "5";
        return "";
    };

    useEffect(() => {
        if (!showModal) return;   // ✅ only when modal is open
        if (!selectedInvoice?.id) return;
        if (!loggedInUser?.empId) return;

        console.log("📡 Fetching Dept Head Approval History...");

        axios.get(
            `/api/invoice/depthead-approval-history/${selectedInvoice.id}`,
            { params: { approverId: loggedInUser.empId } }
        )
            .then(res => {
                const data = res.data;

                console.log("✅ Dept Head History:", data);

                setBackendStatus(data.statusId);

                setSelectedInvoice(prev => ({
                    ...prev,
                    approvalStatus:
                        data.statusId === 12 ? "1" : "2",
                    rejectionSendTo:
                        data.sentBackTo === "PO" ? "3" :
                            data.sentBackTo === "Security" ? "4" :
                                data.sentBackTo === "Vendor" ? "5" : "",
                    comment: data.comments || ""
                }));
            })
            .catch(() => {
                console.log("No dept head final record found.");
            });
    }, [showModal, selectedInvoice?.id, loggedInUser?.empId]);

    const renderDocumentFile = (fileData, fileName, title) => {

        if (!fileData || typeof fileData !== "string" || fileData.trim() === "") {
            return <span style={{ color: "gray" }}>No file uploaded</span>;
        }

        let fileUrl = "";
        let cleanPath = fileData.trim();

        // 🔥 Fix backslashes (Windows paths)
        cleanPath = cleanPath.replace(/\\/g, "/");
        cleanPath = cleanPath.replace(/^~\/?/, ""); 

        // 🔥 Fix wrong folder case (VERY IMPORTANT)
        cleanPath = cleanPath.replace(/^invoicecopy/i, "InvoiceCopy");

        // ✅ Valid full URL
        if (cleanPath.startsWith("http")) {

            // ❌ Fix wrong host like http://invoicecopy/...
            if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
                fileUrl = cleanPath;
            } else {
                fileUrl = `${BASE_URL}/${cleanPath.replace(/^\/+/, "")}`;
            }
        }

        // ✅ Base64 PDF
        else if (cleanPath.startsWith("JVBER")) {
            fileUrl = `data:application/pdf;base64,${cleanPath}`;
        }

        // ✅ Relative path
        else {
            fileUrl = `${BASE_URL.replace(/\/$/, "")}/${cleanPath.replace(/^\/+/, "")}`;
        }

        console.log("Final File URL:", fileUrl); // 🔥 DEBUG

        const displayName =
            fileName ||
            (cleanPath.includes("/") ? cleanPath.split("/").pop() : "Document");

        return (
            <div style={{ display: "flex", flexDirection: "column" }}>

                {/* File Name */}
                <span style={{ color: "#0a4275", fontWeight: "500" }}>
                    {displayName}
                </span>

                {/* Buttons */}
                <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>

                    <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={() => {
                            window.open(fileUrl, "_blank");

                        }}
                    >
                        View
                    </Button>

                    
                </div>
            </div>
        );
    };

    return (
        <DashboardLayout>
            <div className="invoice-container">
                <h2 className="invoice-title" style={{ marginTop: "-75px", marginBottom: '15px', color: '#0a4275', paddingTop: '50px'}}>Invoice Approval Details</h2>
                <div className="vendor-toolbar">
                    {/* 🔹 Search Box — Left Side */}
                    <div className="vendor-toolbar-search">
                        <div className="vendor-search-box invoice-search-box">
                            <span className="vendor-search-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                </svg>
                            </span>
                            <Input
                                type="text"
                                placeholder="Search by Company Name..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                                aria-label="Search by company name"
                                className="vendor-search-input"
                            />
                            {searchTerm && (
                                <button
                                    type="button"
                                    className="vendor-search-clear"
                                    aria-label="Clear search"
                                    onClick={() => {
                                        setSearchTerm("");
                                        setCurrentPage(1);
                                    }}
                                >
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* 🔹 Status Dropdown — Right Side */}
                    <div className="vendor-status-filter">
                        <label className="vendor-status-label">
                            Approved Status:
                        </label>

                        <Input
                            type="select"
                            className="vendor-status-select"
                            value={selectedStatus}
                            onChange={(e) => {
                                setSelectedStatus(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={statusMapping.Pending}>⏳ Pending</option>
                            <option value={statusMapping.Approved}>✔️ Approved</option>
                            <option value={statusMapping.Rejected}>❌ Rejected</option>
                        </Input>
                    </div>
                </div>

                <div className="table-wrapper"></div>
                <table className="invoice-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Company Name</th>
                            <th>Invoice Type</th>
                            <th>Supplier Type</th>
                            <th>Invoice No</th>
                            <th>Total Value</th>
                            <th>DC Number</th>
                            <th>Create Date</th>
                            <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                Approval Status {sortBy === "approvalStatus"
                                    ? (sortOrder === "asc" ? "▲" : "▼")
                                    : "⇅"}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentInvoices.map((invoice, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{invoice.nameOfCompany}</td>
                                <td>{invoice.invoiceType}</td>
                                <td>{invoice.supplierType}</td>
                                <td>{invoice.invoiceNo}</td>
                                <td>{invoice.totalValue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                <td>{invoice.dcnumber}</td>
                                <td>{invoice.createdDate}</td>
                                <td>{invoice.approvalStatus}</td>
                                <td>
                                    <button className="review-btn" onClick={() => handleReviewClick(invoice)}>
                                        Review
                                    </button>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="pagination">
                    <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                    <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                    <span className="page-info">Page {currentPage} of {totalPages}</span>
                    <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                    <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                </div>
            </div>
            <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered>
                <ModalHeader toggle={() => setShowModal(false)}>Invoice Details</ModalHeader>
                <div className="tabs1">
                    <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Vendor Info</span>
                    <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Invoice Approval History</span>
                    <span className={activeTab === "infoInvoice" ? "active-tab" : ""} onClick={() => setActiveTab("infoInvoice")}>Invoice Info</span>
                    <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>

                </div>
                <ModalBody>
                    {activeTab === "details" && (
                        <>
                            <Table bordered className="info-table1">
                                <tbody>

                                    {/* Company */}
                                    <tr>
                                        <th><strong>Name of Company:</strong></th>
                                        <td>{selectedInvoice?.nameOfCompany || "N/A"}</td>
                                        <th></th>
                                        <td></td>
                                    </tr>

                                    {/* Approval + Comments */}
                                    {/* ================= APPROVAL + COMMENTS ================= */}
                                    <tr>
                                        <th>
                                            <strong>Approval Status:</strong>
                                            <span className="required-field">*</span>
                                        </th>
                                        <td>
                                            <Input
                                                type="select"
                                                value={selectedInvoice?.approvalStatus ?? ""}
                                                disabled={isFinalStatus}
                                                onChange={(e) => {
                                                    setSelectedInvoice({
                                                        ...selectedInvoice,
                                                        approvalStatus: e.target.value
                                                    });
                                                    setApprovalStatusError("");
                                                }}
                                            >
                                                <option value="">Select</option>
                                                <option value="1">Approved</option>
                                                <option value="2">Rejected</option>
                                            </Input>
                                            {!isFinalStatus && approvalStatusError && (
                                                <div className="text-danger">{approvalStatusError}</div>
                                            )}
                                        </td>

                                        <th>
                                            <strong>Comments:</strong>
                                            <span className="required-field">*</span>
                                        </th>
                                        <td>
                                            <Input
                                                type="textarea"
                                                value={selectedInvoice?.comment ?? ""}
                                                disabled={isFinalStatus}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setSelectedInvoice(prev => ({
                                                        ...(prev || {}),   // 🔥 prevent null crash
                                                        comment: value
                                                    }));

                                                    setCommentError("");
                                                }}
                                            />
                                            {!isFinalStatus && commentError && (
                                                <div className="text-danger">{commentError}</div>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <strong>Rejection Send To:</strong>
                                            <span className="required-field">*</span>
                                        </th>
                                        <td>
                                            <Input
                                                type="select"
                                                value={selectedInvoice?.rejectionSendTo || ""}
                                                disabled={isFinalStatus || String(selectedInvoice?.approvalStatus) !== "2"}
                                                onChange={(e) => {
                                                    const value = e.target.value;   // ✅ store first

                                                    setSelectedInvoice(prev => ({
                                                        ...(prev || {}),
                                                        rejectionSendTo: value
                                                    }));

                                                    setRejectionSendToError("");    // optional: clear error
                                                }}
                                            >
                                                <option value="">Select</option>
                                                <option value="3">PO</option>
                                                <option value="4">Security</option>
                                                <option value="5">Vendor</option>
                                            </Input>
                                            {rejectionSendToError && selectedInvoice?.approvalStatus === "2" && (
                                                <div className="text-danger">{rejectionSendToError}</div>
                                            )}
                                        </td>
                                        <th></th>
                                        <td></td>
                                    </tr>

                                </tbody>

                            </Table>
                            <ModalFooter>
                                {/*<Button color="success" onClick={handleSaveStatus}>Save</Button>*/}
                                {!isFinalStatus && (
                                    <Button color="success" onClick={handleSaveStatus}>
                                        Save
                                    </Button>
                                )}
                                <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                            </ModalFooter>
                        </>
                    )}
                    {/* Vendor Info Tab */}
                    {activeTab === "info" && selectedVendor && (
                        <VendorInfoTabs
                            selectedVendor={selectedVendor}   // Vendor object
                            vendorFiles={files}               // Vendor files fetched above
                            isEditing={isEditing}
                            setIsEditing={setIsEditing}
                            handleInputChange={(e, field) =>
                                setSelectedVendor({ ...selectedVendor, [field]: e.target.value })
                            }
                            subTab={subTab}
                            setSubTab={setSubTab}
                            type="invoice"
                        />
                    )}


                    {activeTab === "infoInvoice" && invoiceInfo && (
                        <>
                            <Table bordered className="info-table1">
                                <tbody>
                                    <tr>
                                        <th><strong>Invoice Type:</strong></th>
                                        <td>{invoiceInfo.invoiceType || "N/A"}</td>
                                        <th><strong>Supplier Type:</strong></th>
                                        <td>
                                            {invoiceInfo.invoiceSupplierType === 1
                                                ? "Supply of Goods"
                                                : invoiceInfo.invoiceSupplierType === 2
                                                    ? "Supply of Service"
                                                    : "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><strong>Invoice Document:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.invoiceFilePath,
                                                invoiceInfo.fileName,
                                                "Invoice Document Preview"
                                            )}
                                        </td>
                                        <th><strong>Invoice Date:</strong></th>
                                        <td>
                                            {invoiceInfo.invoiceDate
                                                ? new Date(invoiceInfo.invoiceDate).toLocaleDateString("en-GB")
                                                : "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>Invoice No:</strong></th>
                                        <td>{invoiceInfo.invoiceNo || "N/A"}</td>
                                        <th><strong>PO No:</strong></th>
                                        <td>{invoiceInfo.pono || "N/A"}</td>
                                    </tr>

                                    <tr>
                                        <th><strong>Delivery Challan No:</strong></th>
                                        <td>{invoiceInfo.deliveryChallanNumber || "N/A"}</td>
                                        <th><strong>Invoice Value:</strong></th>
                                        <td>{invoiceInfo.invoiceValue?.toFixed(2) || "0.00"}</td>
                                    </tr>

                                    <tr>
                                        <th><strong>IGST:</strong></th>
                                        <td>{invoiceInfo.igst?.toFixed(2) || "0.00"}</td>
                                        <th><strong>CGST:</strong></th>
                                        <td>{invoiceInfo.cgst?.toFixed(2) || "0.00"}</td>
                                    </tr>

                                    <tr>
                                        <th><strong>SGST:</strong></th>
                                        <td>{invoiceInfo.sgst?.toFixed(2) || "0.00"}</td>
                                        <th><strong>Total Value:</strong></th>
                                        <td>{invoiceInfo.totalValue?.toFixed(2) || "0.00"}</td>

                                    </tr>

                                    <tr>
                                        <th><strong>Created Date:</strong></th>
                                        <td>
                                            {invoiceInfo.createdDate
                                                ? new Date(invoiceInfo.createdDate).toLocaleDateString("en-GB")
                                                : "N/A"}
                                        </td>
                                        <th><strong>Agreement Document:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.agreementFilePath,
                                                invoiceInfo.fileNameAgreement,
                                                "Agreement Document Preview"
                                            )}
                                        </td>
                                    </tr>

                                    {/*<tr>*/}
                                    {/*    <th><strong>Email Approval:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.emailApproval ? (*/}
                                    {/*            <a href={invoiceInfo.emailApproval} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*    <th><strong>Invoice:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.Invoice ? (*/}
                                    {/*            <a href={invoiceInfo.invoice} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*</tr>*/}
                                    <tr>
                                        <th><strong>Email Approval:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.emailApprovalFilePath,
                                                "Email Approval",
                                                "Email Approval Preview"
                                            )}
                                        </td>

                                        <th><strong>Invoice (PO Upload):</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.invoiceIMAGEFilePath,
                                                "Invoice Document",
                                                "Invoice Preview"
                                            )}
                                        </td>
                                    </tr>
                                    {/*<tr>*/}
                                    {/*    <th><strong>PO Attachment:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.poAttachment ? (*/}
                                    {/*            <a href={invoiceInfo.poAttachment} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*    <th><strong>PR Attachment:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.prAttachment ? (*/}
                                    {/*            <a href={invoiceInfo.prAttachment} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*</tr>*/}
                                    <tr>
                                        <th><strong>PO Attachment:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.poimageFilePath,
                                                "PO Document",
                                                "PO Preview"
                                            )}
                                        </td>

                                        <th><strong>PR Attachment:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.primageFilePath,
                                                "PR Document",
                                                "PR Preview"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>Quotation:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.quotationIMAGEFilePath,
                                                "Quotation 1",
                                                "Quotation Preview"
                                            )}
                                        </td>
                                        <th><strong>More Quotation:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.quotation2IMAGEFilePath,
                                                "Quotation 2",
                                                "Quotation Preview"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        {/*<th><strong>Comparison Quotes:</strong></th>*/}
                                        {/*<td>*/}
                                        {/*    {invoiceInfo.comparisonDocument ? (*/}
                                        {/*        <a href={invoiceInfo.comparisonDocument} target="_blank" rel="noopener noreferrer">*/}
                                        {/*            View*/}
                                        {/*        </a>*/}
                                        {/*    ) : "N/A"}*/}
                                        {/*</td>*/}
                                        <th><strong>Comparison Quotes:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.comparisonquotesFilePath,
                                                "Comparison Quotes",
                                                "Comparison Preview"
                                            )}
                                        </td>
                                        <th><strong>Evaluation Form:</strong></th>
                                        <td>
                                            {invoiceInfo.evaluationForm ? (
                                                <a href={invoiceInfo.evaluationForm} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>Other Documents:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.otherDocuementsIMAGEFilePath,
                                                "Other Documents",
                                                "Other Documents Preview"
                                            )}
                                        </td>
                                        <th><strong>TimeSheet:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.timeSheetFilePath,
                                                invoiceInfo.fileNameTimeSheet,
                                                "TimeSheet Preview"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>GRN Attachment:</strong></th>
                                        <td>
                                            {invoiceInfo.grnAttachment ? (
                                                <a href={invoiceInfo.grnAttachment} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                        <th><strong>Quotation 3:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.quotation3IMAGEFilePath,
                                                "Quotation 3",
                                                "Quotation 3 Preview"
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                            {/* GRN Items Section */}
                            <h5 className="text-primary fw-bold mb-3">
                                The Following goods has been Received.
                            </h5>

                            <table className="table table-bordered align-middle table-hover invoice-table">
                                <thead className="table-header text-center">
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Description</th>
                                        <th>Ordered Qty</th>
                                        <th>Supplied Qty</th>
                                        <th>Invoice Value</th>
                                        <th>CGST (%)</th>
                                        <th>SGST (%)</th>
                                        <th>IGST (%)</th>
                                        <th>Total Value</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceInfo?.grnItems?.length > 0 ? (
                                        invoiceInfo.grnItems.map((item, index) => (
                                            <tr key={item.id} className="text-center">
                                                <td>{startIndex + index + 1}</td>
                                                <td className="text-start">{item.description || "-"}</td>
                                                <td>{item.qty ?? 0}</td>
                                                <td>{item.rcvQty ?? 0}</td>
                                                <td>{item.invoiceValue?.toFixed(2) ?? "0.00"}</td>
                                                <td>{item.cgst ?? 0}</td>
                                                <td>{item.sgst ?? 0}</td>
                                                <td>{item.igst ?? 0}</td>
                                                <td>{item.totalValue?.toFixed(2) ?? "0.00"}</td>
                                                <td>{item.remark || "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: "center" }}>No GRN Items Available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </>
                    )}
                    {activeTab === "history" && (
                        <div className="history-container1">

                            <table className="history-table1">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Approval Status</th>
                                        <th>Approver Name</th>
                                        <th>Date</th>
                                        <th>Comments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historyData.length > 0 ? (
                                        historyData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.approvalStatus || "N/A"}</td> {/* lowercase */}
                                                <td>{item.approvalname || "N/A"}</td>
                                                <td>
                                                    {item.createdate
                                                        ? new Date(item.createdate).toLocaleDateString("en-GB")
                                                        : "N/A"}
                                                </td>
                                                <td>{item.comments || "N/A"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">No history found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                </ModalBody>
                {/* 🔵 Preview Modal */}
                <Modal
                    isOpen={showPreview}
                    toggle={() => setShowPreview(false)}
                    size="lg"
                    centered
                >
                    <ModalHeader toggle={() => setShowPreview(false)}>
                        {previewTitle}
                    </ModalHeader>

                    <ModalBody style={{ padding: 0 }}>
                        {previewUrl ? (
                            <iframe
                                src={previewUrl}
                                title="Preview"
                                style={{
                                    width: "100%",
                                    height: "80vh",
                                    border: "none"
                                }}
                            />
                        ) : (
                            <p style={{ padding: "20px" }}>No preview available</p>
                        )}
                    </ModalBody>
                </Modal>

            </Modal>

        </DashboardLayout>
    );
};
export default ViewAllInvoicesDeptHead;
